import {
    buildCanonicalPath,
    saveSearchAndAlertUrlFixer,
    formatListings,
    getFeaturedListingsToDisplay
} from 'search/helpers';
import {
    ServerData,
    SearchContextType,
    mapDataToActions,
    searchReducer
} from 'search/SearchContext';
import { mapTargetingFilters } from 'shared/components/Adverts/lib';

export const getServerRenderedData = (
    serverSideData: ServerData,
    initialState: SearchContextType
) => {
    const {
        searchResults: {
            metaInfo,
            listings,
            pagination: { totalResults, pageNumber, totalResultsWasLimited },
            sortOrder,
            filters: { fields },
            analyticsTaxonomy,
            links,
            polyenc,
            polygon,
            seoBlurb: { transactionType }
        }
    } = serverSideData;
    const { regular, extended, featured } = listings;

    const searchContextData = mapDataToActions(serverSideData).reduce(
        searchReducer,
        initialState
    );

    const canonicalPath = buildCanonicalPath(metaInfo.canonicalUri || '');

    const formattedLinks = {
        createAlert: saveSearchAndAlertUrlFixer(links?.createAlert),
        saveSearch: saveSearchAndAlertUrlFixer(links?.saveSearch),
        mapView: saveSearchAndAlertUrlFixer(links?.mapView)
    };

    return {
        regularListingsFormatted: formatListings(regular),
        extendedListingsFormatted: formatListings(extended),
        featuredProperties: getFeaturedListingsToDisplay(featured || []),
        searchContextData,
        canonicalPath,
        totalResults,
        sortOrder,
        filtersFields: fields,
        pageNumber,
        totalResultsWasLimited,
        analyticsTaxonomy,
        polyenc,
        polygon,
        filtersTargeting: mapTargetingFilters(fields),
        transactionType,
        links: formattedLinks
    };
};
